/** Per-linje feltfejl (kun de felter editoren viser). */
export interface ItemFieldErrors {
  product?: string;
  claimType?: string;
  orderNumber?: string;
  b2cMobileNumber?: string;
  quantity?: string;
}

export interface ParsedClaimErrors {
  /** Per varelinje-index. */
  items: Record<number, ItemFieldErrors>;
  /** Ikke-linje-fejl (fx preferred_outcome). */
  top: string[];
  /** Laveste index med fejl (til at navigere brugeren hen til linjen), ellers null. */
  firstItemIndex: number | null;
}

/** Server-snake_case feltnavn → editor-camelCase nøgle. */
const FIELD_MAP: Record<string, keyof ItemFieldErrors> = {
  sku: 'product',
  product_name: 'product',
  claim_type: 'claimType',
  order_number: 'orderNumber',
  b2c_mobile_number: 'b2cMobileNumber',
  quantity: 'quantity',
};

export function parseClaimFieldErrors(fieldErrors?: Record<string, string[]>): ParsedClaimErrors {
  const items: Record<number, ItemFieldErrors> = {};
  const top: string[] = [];
  if (!fieldErrors) return { items, top, firstItemIndex: null };

  for (const [path, msgs] of Object.entries(fieldErrors)) {
    const msg = msgs[0] ?? 'Ugyldigt felt.';
    const m = /^items\.(\d+)\.(.+)$/.exec(path);
    if (m) {
      const idx = Number(m[1]);
      const key = FIELD_MAP[m[2]];
      if (key) {
        items[idx] = { ...items[idx], [key]: msg };
      } else {
        (items[idx] = items[idx] ?? {});
      }
    } else {
      top.push(msg);
    }
  }

  const indices = Object.keys(items).map(Number);
  return { items, top, firstItemIndex: indices.length ? Math.min(...indices) : null };
}
